module.exports = __webpack_public_path__ + "img/waistline_small.8c66a132.png";